import React from "react";
import COLORS from "../../constants/colors";
import FlowTopBar from "../common/FlowTopBar";
import MaskedInputPlaceholder from "../common/MaskedInputPlaceholder";
import {
  heroWordStyle,
  mainCardStyle,
  pageStyle,
  primaryBtnStyle,
  centerSubStyle,
} from "../../styles/commonStyles";
import { speakFrench } from "../../utils/speech";

export default function LearnPhaseThree({
  word,
  progressText,
  inputValue,
  checkResult, // idle | correct | wrong
  onChangeInput,
  onCheck,
  onPrev,
  onStar,
  onSkip,
  onHome,
  disablePrev = false,
}) {
  const isComposingRef = React.useRef(false);
  const [localValue, setLocalValue] = React.useState(inputValue ?? "");

  React.useEffect(() => {
    if (!isComposingRef.current) {
      setLocalValue(inputValue ?? "");
    }
  }, [inputValue]);

  if (!word) return null;

  return (
    <div style={pageStyle()}>
      <div style={mainCardStyle()}>
        <FlowTopBar
          title={`学习进度：${progressText}`}
          onPrev={onPrev}
          onStar={onStar}
          onSkip={onSkip}
          onHome={onHome}
          disablePrev={disablePrev}
        />

        <div style={heroWordStyle()}>{word.word}</div>

        <div
          onClick={() => speakFrench(word.word)}
          style={{ ...centerSubStyle(), cursor: "pointer" }}
        >
          {word.phonetic} 🔊
        </div>

        <MaskedInputPlaceholder />

        <div
          style={{
            marginTop: "1.4rem",
            textAlign: "center",
            color: COLORS.text,
            fontWeight: 700,
            fontSize: "1.05rem",
          }}
        >
          请输入中文意思
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
          <input
            type="text"
            value={localValue}
            onCompositionStart={() => { isComposingRef.current = true; }}
            onCompositionEnd={(e) => {
              isComposingRef.current = false;
              setLocalValue(e.target.value);
              onChangeInput(e.target.value);
            }}
            onChange={(e) => {
              setLocalValue(e.target.value);
              if (!isComposingRef.current) {
                onChangeInput(e.target.value);
              }
            }}
            autoComplete="off"
            spellCheck="false"
            placeholder="请输入中文释义"
            style={{
              width: "100%",
              maxWidth: "420px",
              border: "none",
              outline: "none",
              borderBottom: `3px solid ${
                checkResult === "correct"
                  ? COLORS.green
                  : checkResult === "wrong"
                  ? COLORS.red
                  : "#C9CDD4"
              }`,
              padding: "0.8rem 0.4rem",
              fontSize: "1.15rem",
              textAlign: "center",
              background: "transparent",
              color: COLORS.text,
            }}
          />
        </div>

        {checkResult === "correct" && (
          <div
            style={{
              textAlign: "center",
              marginTop: "1rem",
              color: COLORS.green,
              fontWeight: 700,
            }}
          >
            回答正确，正在进入下一个页面
          </div>
        )}

        {checkResult === "wrong" && (
          <div
            style={{
              textAlign: "center",
              marginTop: "1rem",
              color: COLORS.red,
              fontWeight: 700,
            }}
          >
            回答不正确，请重新输入
          </div>
        )}

        <button
          onClick={onCheck}
          style={{
            ...primaryBtnStyle(),
            width: "100%",
            marginTop: "1.6rem",
          }}
        >
          提交检查
        </button>
      </div>
    </div>
  );
}